export default __webpack_public_path__ + "static/media/loading.34fd2a00.png";